import React, { FC } from 'react';

import { Button } from 'antd';
import {
  IChallengeResourceConfig,
  IChallengeResourceRender,
} from 'src/shared/models';
import { completeChallengeUserResource } from 'utils';

interface OwnProps extends IChallengeResourceRender {
  config: IChallengeResourceConfig;
  idResource: number;
}

const ChallengeActivationButton: FC<OwnProps> = ({
  config,
  idResource,
  updateUserPoints,
  updateChallenge,
}): JSX.Element => {
  if (!config) return <React.Fragment />;

  const { isCompleted, title } = config;

  return (
    !isCompleted && (
      <Button
        onClick={() => {
          completeChallengeUserResource({
            idResource,
            updateChallenge,
            updateUserPoints,
          });
        }}
        type="primary"
        className="btn-primary btn-primary--black"
      >
        {title}
      </Button>
    )
  );
};

export default ChallengeActivationButton;
